import { EmptyStateWithAction } from 'app/ProfileRevampPage/components/EmptyState'
import { LoadingState } from 'app/ProfileRevampPage/components/LoadingState'
import Notification from 'app/ProfileRevampPage/components/Notification'
import DescriptionCard from 'app/ProfileRevampPage/components/DescriptionCard'
import SocialMediaCard from 'app/ProfileRevampPage/components/SocialMediaCard'
import CommunityCard from 'app/ProfileRevampPage/components/CommunityCard'
import { useProfile } from 'app/ProfileRevampPage/hooks/useProfile'
import { useProfileInfo } from 'app/ProfileRevampPage/hooks/useProfileInfo'

const SectionInfo = () => {
  const { isCurrentUser, profileData, hasCommunity } = useProfile()
  const {
    profileInfoData,
    profileInfoFetchStatus,
    hasSocialMedia,
    isProfileInfoEmpty,
  } = useProfileInfo()

  const infoTitle = {
    tentangSaya: 'TENTANG SAYA',
    kegiatanLain: 'KEGIATAN LAIN',
    pencapaian: 'PENCAPAIAN',
    pepatah: 'SEMBOYAN',
  }

  return (
    <>
      {profileInfoFetchStatus === 'loading' && (
        <div className="p-4">
          <LoadingState />
        </div>
      )}

      {profileInfoFetchStatus === 'success' && (
        <>
          {isCurrentUser ? (
            <Notification data-testid="profile-notification-self-view">
              Rekan guru Anda bisa melihat semua informasi di bawah.
            </Notification>
          ) : null}

          <div className="p-4">
            {isProfileInfoEmpty && !hasCommunity && !isCurrentUser && (
              <EmptyStateWithAction
                data-testid="profile-empty-state-info"
                className="mt-4"
                title="Belum ada info"
                description={`${profileData?.name} belum mengisi bagian ini.`}
              />
            )}

            {Object.keys(infoTitle).map((key) => {
              if (!Boolean(profileInfoData?.[key]) && !isCurrentUser) {
                return null
              }

              return (
                <DescriptionCard
                  key={`profile-info-${key}`}
                  title={infoTitle[key]}
                  description={profileInfoData?.[key]}
                />
              )
            })}

            {hasSocialMedia ? (
              <SocialMediaCard data={profileInfoData?.socialMedia} />
            ) : null}

            {!hasSocialMedia && isCurrentUser && (
              <DescriptionCard title="MEDIA SOSIAL" />
            )}

            <CommunityCard />
          </div>
        </>
      )}
    </>
  )
}

export default SectionInfo
